import script from "./AppBaner.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBaner.vue?vue&type=script&setup=true&lang=js"

import "./AppBaner.vue?vue&type=style&index=0&id=5f390ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f390ae8"]])

export default __exports__